import * as React from "react";
import formatDate from "dateformat";
import ContentCard from "../../../../../ui-library/content-card/content-card";
import CardContent from "../../../../../ui-library/content-card/card-content";
import CardHeading from "../../../../../ui-library/content-card/card-heading";
import CardSubHeading from "../../../../../ui-library/content-card/card-sub-heading";
import { CountryItem } from "../../../../../../types/country";
import { GrowthFactorByCountries_covidCaseOwidByCountries_data } from "../../../../../../apollo-types/GrowthFactorByCountries";
import CountryInfectionRate from "../../infection-rate/country-infection-rate";
import { formatNumberDisplay } from "../../../../../../utils/format-number";
import styles from "./infection-rate-card.styles";

interface InfectionRateCardProps {
  benchmarkCountry?: CountryItem;
  country: string;
  countryName: string;
  data?: GrowthFactorByCountries_covidCaseOwidByCountries_data[] | null;
  covidBenchmarkData?:
    | GrowthFactorByCountries_covidCaseOwidByCountries_data[]
    | null;
  loading?: boolean;
}

const InfectionRateCard: React.FC<InfectionRateCardProps> = ({
  benchmarkCountry,
  country,
  countryName,
  data,
  covidBenchmarkData,
  loading,
}) => {
  let highest = data ? data[0] : undefined;
  let lowest = data ? data[0] : undefined;

  if (data) {
    data.forEach((d) => {
      if (d) {
        if (
          d.infectionRate &&
          d.infectionRate > (highest?.infectionRate || -1000)
        ) {
          highest = d;
        }
        if (
          d.infectionRate &&
          d.infectionRate < (lowest?.infectionRate || 1000)
        ) {
          lowest = d;
        }
      }
    });
  }
  return (
    <ContentCard>
      <CardContent>
        <CardHeading>Last 30 days infection rate</CardHeading>
        <CardSubHeading>
          {countryName} needs to keep the infection rate below 1.0 to control
          the outbreak
        </CardSubHeading>

        <CountryInfectionRate
          countryName={country === "World" ? "Worldwide" : countryName}
          data={data}
          benchmarkCountryName={benchmarkCountry?.countryName}
          benchmarkData={covidBenchmarkData}
          loading={loading}
        />
        {data && (
          <div css={styles.content}>
            {!!highest && (
              <div css={styles.detail}>
                Highest on {formatDate(highest.date, "mmm d")}{" "}
                <span>{formatNumberDisplay(highest.infectionRate!)}</span>
              </div>
            )}
            {!!lowest && (
              <div css={styles.detail}>
                Lowest on {formatDate(lowest.date, "mmm d")}{" "}
                <span>{formatNumberDisplay(lowest.infectionRate!)}</span>
              </div>
            )}
          </div>
        )}
      </CardContent>
    </ContentCard>
  );
};

export default InfectionRateCard;
